import { NewsTeaser } from "./NewsTeaser";
import { NewsCard } from "./NewsCard";
import {NewsIndexCard} from "./NewsIndexCard";

export {NewsTeaser, NewsCard, NewsIndexCard, };
